import React, { useState, useEffect } from "react";
import Select from "react-select";
import { createUser, updateUser } from "../../services/userService";
import { toast } from "react-toastify";

const roleOptions = [
    { value: "admin", label: "Admin" },
    { value: "user", label: "User" },
];

const statusOptions = [
    { value: "a", label: "Active" },
    { value: "i", label: "Inactive" },
];

const initialForm = {
    name: "",
    email: "",
    phone: "",
    password: "",
    role: "user",
    status: "a",
};

const UserModal = ({ open, onClose, user, refresh }) => {
    const [form, setForm] = useState(initialForm);

useEffect(() => {
        if (user) {
            setForm({
                ...initialForm,
                ...user,
            });
        } else {
            setForm(initialForm);
        }
    }, [user, open]);

const handleSubmit = async () => {

    const toastId = toast.loading(user ? "Updating user..." : "Creating user...");

    try {

        if (user) {
            await updateUser(user.id, form);

            toast.update(toastId, {
                render: "User updated successfully",
                type: "success",
                isLoading: false,
                autoClose: 3000,
            });

        } else {

            await createUser(form);

            toast.update(toastId, {
                render: "User created successfully",
                type: "success",
                isLoading: false,
                autoClose: 3000,
            });
        }

        refresh();
        onClose();
        setForm(initialForm);

    } catch (err) {

        console.log(err);

        toast.update(toastId, {
            render: err?.message || "Something went wrong",
            type: "error",
            isLoading: false,
            autoClose: 4000,
        });
    }
};

    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white w-full max-w-2xl rounded-2xl p-8 shadow-2xl">
                <h2 className="text-2xl font-bold mb-6">
                    {user ? "Edit User" : "Create User"}
                </h2>

                <div className="grid grid-cols-2 gap-5">
                    <input
                        className="border rounded-xl p-3"
                        placeholder="Name"
                        value={form.name}
                        onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                        }
                    />

                    <input
                        className="border rounded-xl p-3"
                        placeholder="username"
                        value={form.email}
                        onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                        }
                    />

                    <input
                        className="border rounded-xl p-3"
                        placeholder="mobile"
                        value={form.phone}
                        onChange={(e) =>
                            setForm({ ...form, phone: e.target.value })
                        }
                    />

                     <input
                        className="border rounded-xl p-3"
                        type="password"
                        placeholder="password"
                        value={form.password}
                        onChange={(e) =>
                            setForm({ ...form, password: e.target.value })
                        }
                    />

                    <Select
                        options={roleOptions}
                        isClearable
                        value={roleOptions.find(
                            (r) => r.value === form.role
                        )}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                role: e?.value || "",
                            })
                        }
                    />

                    <Select
                        options={statusOptions}
                        isClearable
                        value={statusOptions.find(
                            (s) => s.value === form.status
                        )}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                status: e?.value || "",
                            })
                        }
                    />
                </div>

                <div className="flex justify-end gap-4 mt-8">
                    <button
                        onClick={onClose}
                        className="px-5 py-2 rounded-xl border"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={handleSubmit}
                        className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-xl"
                    >
                        {user ? "Update User" : "Create User"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserModal;
